import { useAppInsightsPageViewTracker } from "core/analytics/app-insights/app-insights.hooks";
import { useGoogleAnalyticsPageTracking } from "core/analytics/google-analytics/google-analitics.hooks";

import { logout, useUserInactivity } from "@bps/msal";

import { usePermissionsChecker } from "../core/auth/Permissions";
import { Permission } from "../core/common-types/permission.enum";
import { config } from "../core/config";

export const AppTrackers = () => {
  const hasPermission = usePermissionsChecker();
  useUserInactivity(
    () => logout({ postLogoutRedirectUri: window.location.href }),
    {
      timeoutMins: config.userInactivityTimeoutMins,
      disabled: !hasPermission(Permission.ProsInactivityTimeoutAllowed)
    }
  );

  useAppInsightsPageViewTracker();
  useGoogleAnalyticsPageTracking();

  return null;
};
